import { motion } from "framer-motion";
import { Quote } from "lucide-react";

const TESTIMONIALS = [
  {
    quote: "Gold Link transformed our 4-story tech campus. Nightly compliance reports give us total confidence.",
    author: "Marcus Vance",
    role: "Facilities Director, Nexus Tech Tower",
  },
  {
    quote: "Post-concert cleanups used to take 14 hours. Gold Link gets our 8,000-seat arena pristine in under 5.",
    author: "Elena Rostova",
    role: "Operations Manager, Grand Apex Arena",
  },
  {
    quote: "Hospital-grade standards for our care facility. Spotless, punctual, and remarkably quiet.",
    author: "Dr. Aris Thorne",
    role: "Managing Director, St. Jude Care Residence",
  },
];

export const Testimonials = () => (
  <section
    id="testimonials"
    data-testid="testimonials-section"
    className="relative py-24 sm:py-32 bg-navy-950"
  >
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.7 }}
        className="mb-14 flex items-end justify-between flex-wrap gap-6"
      >
        <div>
          <p className="eyebrow mb-4">Client Endorsements</p>
          <h2 className="font-heading font-bold text-2xl sm:text-3xl lg:text-4xl tracking-tight text-ice-50 leading-snug">
            Trusted where it matters most.
          </h2>
        </div>
        <span
          data-testid="testimonials-sample-badge"
          className="font-mono text-[10px] uppercase tracking-[0.22em] text-gold-500 border border-gold-500/40 rounded-full px-4 py-1.5"
        >
          Sample Only
        </span>
      </motion.div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {TESTIMONIALS.map((t, i) => (
          <motion.figure
            key={t.author}
            data-testid={`testimonial-card-${i}`}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-40px" }}
            transition={{ duration: 0.6, delay: i * 0.1 }}
            className="bg-navy-800/50 border border-white/5 rounded-xl p-8 flex flex-col hover:border-gold-500/30 transition-colors duration-300"
          >
            <Quote className="w-7 h-7 text-gold-500 mb-6" />
            <blockquote className="text-base leading-relaxed text-ice-200/80 flex-1">
              “{t.quote}”
            </blockquote>
            <figcaption className="mt-8 pt-6 border-t border-white/10">
              <p className="font-heading font-semibold text-sm text-ice-50">
                {t.author}
              </p>
              <p className="font-mono text-[10px] uppercase tracking-[0.18em] text-ice-200/50 mt-1">
                {t.role}
              </p>
            </figcaption>
          </motion.figure>
        ))}
      </div>
    </div>
  </section>
);
